import { render } from "./sidebar.vue?vue&type=template&id=626724b4"
import script from "./sidebar.vue?vue&type=script&lang=ts"
export * from "./sidebar.vue?vue&type=script&lang=ts"

import "./sidebar.vue?vue&type=style&index=0&id=626724b4&lang=scss"
script.render = render

export default script